export default __webpack_public_path__ + "static/immerseYourself-3527088a7aabc67f89d634fb50d506dd.png";